// extracted by mini-css-extract-plugin
module.exports = {"brand-illustration-info-card__content":"StoryblokBrandIllustrationInfoCard_brand-illustration-info-card__content__wJUQ8"};